export const VITE_OTP_GATEWAY_URL = import.meta.env.VITE_OTP_GATEWAY_URL;
export const VITE_ZEM_GATEWAY_URL = import.meta.env.VITE_ZEM_GATEWAY_URL;
export const LOAN_PURPOSE_PERSONAL = "Personal";
export const LOAN_PURPOSE_BUSINESS = "Business";
export const LOAN_PURPOSE_NOVATED_LEASE = "Novated Lease";
export const LOAN_PURPOSE_NEW = "New";
export const LOAN_PURPOSE_DEBT_CONSOLIDATION_REFINANCING = "Debt Consolidation / Refinancing";
export const EMP_STAT_SELF_EMPLOYED = "Self-employed";
export const ABN_STATUS_NEW_ABN = "New Business ABN";
export const BOAT_ASSET_TYPE_COMMERCIAL = "Commercial Boat";

// Initialised loan types
export const ALL_LOAN_TYPES =
	"Car Loan,Boat Loan,Caravan Loan,Truck Loan,Equipment Loan,Motorcycle Loan,Personal Loan,Business Loan";
export const LOAN_TYPE_PERSONAL = "Personal Loan";
export const LOAN_TYPE_CAR = "Car Loan";
export const LOAN_TYPE_BOAT = "Boat Loan";
export const LOAN_TYPE_BIKE = "Bike Loan";
export const LOAN_TYPE_MOTORCYCLE = "Motorcycle Loan";
export const LOAN_TYPE_CARAVAN = "Caravan Loan";
export const LOAN_TYPE_TRUCK = "Truck Loan";
export const LOAN_TYPE_EQUIPMENT = "Equipment Loan";
export const LOAN_TYPE_BUSINESS = "Business Loan";

// Assets used in partner pages
export const ASSET_TYPE_CAR = "Cars";
export const ASSET_TYPE_CARAVAN = "Caravans";
export const ASSET_TYPE_TRUCK = "Trucks";
export const ASSET_TYPE_EQUIPMENT = "Equipment";
export const ASSET_TYPE_BEAUTY = "Beauty Equipment";
export const ASSET_TYPE_BIKE = "Bikes";
export const ASSET_TYPE_BOAT = "Boats";
export const ASSET_TYPE_PERSONAL = "Personal";
export const LOANTYPES_WLOANPURPOSE = [ASSET_TYPE_CAR, ASSET_TYPE_BOAT];

// Email typos
export const emailTypos: Record<string, string> = {
	// GMAIL
	"gamil.com": "gmail.com",
	"gmal.com": "gmail.com",
	"gmaill.com": "gmail.com",
	"gmial.com": "gmail.com",
	"gmaii.com": "gmail.com",
	"gamil.com.au": "gmail.com.au",
	"gmail.con": "gmail.com",
	"gmail.con.au": "gmail.com.au",

	// OUTLOOK
	"outlook.con": "outlook.com",
	"outlok.com": "outlook.com",
	"outllok.com": "outlook.com",
	"outlook.con.au": "outlook.com.au",

	// YAHOO
	"yaho.com": "yahoo.com",
	"yaboo.com.au": "yahoo.com.au",
	"yahoo.con.au": "yahoo.com.au",
	"yaho.com.au": "yahoo.com.au",
	"yahoo.con": "yahoo.com",
	"yhoo.com": "yahoo.com",

	// HOTMAIL
	"htmail.com": "hotmail.com",
	"hotmail.con": "hotmail.com",
	"hotmial.com": "hotmail.com",
	"hotmail.con.au": "hotmail.com.au",

	// ICLOUD / BIGPOND
	"icloud.con": "icloud.com",
	"iclou.com": "icloud.com",
	"bigpond.con": "bigpond.com",
	"bigpond.com.au": "bigpond.com",
	"bigpond.con.au": "bigpond.com",
};

export const stateOption = [
	{
		option: "QLD",
		value: "QLD",
	},
	{
		option: "NSW",
		value: "NSW",
	},
	{
		option: "SA",
		value: "SA",
	},
	{
		option: "NT",
		value: "NT",
	},
	{
		option: "WA",
		value: "WA",
	},
	{
		option: "TAS",
		value: "TAS",
	},
	{
		option: "ACT",
		value: "ACT",
	},
	{
		option: "VIC",
		value: "VIC",
	},
];

export const loan_type = [
	{
		option: "Car Loan",
		id: 1,
		value: "Car Loan",
	},
	{
		option: "Boat Loan",
		id: 2,
		value: "Boat Loan",
	},
	{
		option: "Truck Loan",
		id: 8,
		value: "Truck Loan",
	},
	{
		option: "Equipment Loan",
		id: 6,
		value: "Equipment Loan",
	},
	{
		option: "Caravan Loan",
		id: 4,
		value: "Caravan Loan",
	},
	{
		option: "Motorcycle Loan",
		id: 3,
		value: "Motorcycle Loan",
	},
	{
		option: "Personal Loan",
		id: 5,
		value: "Personal Loan",
	},
	{
		option: "Business Loan",
		id: 5,
		value: "Business Loan",
	},
];

export const loan_purpose = [
	{
		option: "Personal",
		id: 1,
		value: "Personal",
	},
	{
		option: "Business",
		id: 2,
		value: "Business",
	},
];

export const car_loan_purpose = [
	{
		option: "Personal",
		id: 1,
		value: "Personal",
	},
	{
		option: "Business",
		id: 2,
		value: "Business",
	},
	{
		option: "Novated Lease",
		id: 1,
		value: "Novated Lease",
	},
];

export const personal_loan_purpose = [
	{
		option: LOAN_PURPOSE_NEW,
		value: LOAN_PURPOSE_NEW,
	},
	{
		option: LOAN_PURPOSE_DEBT_CONSOLIDATION_REFINANCING,
		value: LOAN_PURPOSE_DEBT_CONSOLIDATION_REFINANCING,
	},
];

export const boat_asset_type = [
	{
		option: "Boat",
		value: "Boat",
	},
	{
		option: "Jet Ski / PWC",
		value: "Jet Ski / PWC",
	},
	{
		option: "Sailboat / Yacht",
		value: "Sailboat / Yacht",
	},
	{
		option: "Houseboat",
		value: "Houseboat",
	},
	{
		option: "Commercial Boat",
		value: "Commercial Boat",
	},
];

export const equipment_asset_type = [
	{
		option: "Assets",
		value: "Assets",
	},
	{
		option: "Vehicle",
		value: "Vehicle",
	},
	{
		option: "Cashflow",
		value: "Cashflow",
	},
	{
		option: "General",
		value: "General",
	},
];

export const purchase_stage = [
	{
		option: "Actively Looking",
		value: "Actively Looking",
	},
	{
		option: "Found One - Ready to Finance",
		value: "Found One - Ready to Finance",
	},
	{
		option: "Refinance Existing",
		value: "Refinance Existing",
	},
];

export const living_status = [
	{
		option: "Home Owner - With Mortgage",
		id: 1,
		value: "Home Owner - With Mortgage",
	},
	{
		option: "Home Owner - No Mortgage",
		id: 2,
		value: "Home Owner - No Mortgage",
	},
	{
		option: "Renting",
		id: 3,
		value: "Renting",
	},
	{
		option: "Living with Family",
		id: 4,
		value: "Living with Family",
	},
];

export const employment_status = [
	{
		option: "Full time",
		id: 1,
		value: "Full time",
	},
	{
		option: "Part time",
		id: 2,
		value: "Part time",
	},
	{
		option: "Casual",
		id: 3,
		value: "Casual",
	},
	{
		option: "Self-employed",
		id: 4,
		value: "Self-employed",
	},
	{
		option: "Contractor",
		id: 11,
		value: "Contractor",
	},
	{
		option: "Retired",
		id: 9,
		value: "Retired",
	},
	{
		option: "Self-funded Retiree",
		id: 10,
		value: "Self-funded Retiree",
	},
	{
		option: "Government Benefits",
		id: 7,
		value: "Government Benefits",
	},
];

export const credit_history = [
	{
		option: "Good",
		value: "Good",
	},
	{
		option: "Fair",
		value: "Fair",
	},
	{
		option: "Paid Defaults",
		value: "Paid Defaults",
	},
	{
		option: "Un-Paid Defaults",
		value: "Un-Paid Defaults",
	},
	{
		option: "Ex Bankrupt",
		value: "Ex Bankrupt",
	},
	{
		option: "Unsure",
		value: "Unsure",
	},
];

export const abn_status = [
	{
		option: "New Business ABN",
		value: "New Business ABN",
	},
	{
		option: "Less than 1 Year",
		value: "Less than 1 Year",
	},
	{
		option: "More than 1 Year",
		value: "More than 1 Year",
	},
];

export const gst_status = [
	{
		option: "Not registered for GST",
		value: "Not registered for GST",
	},
	{
		option: "6 Months +",
		value: "6 Months +",
	},
	{
		option: "12 Months +",
		value: "12 Months +",
	},
];

export const loanFieldsMap: Record<string, Record<string, any[]>> = {
	"Car Loan": {
		loanPurpose: [...car_loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Boat Loan": {
		loanPurpose: [...loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [...boat_asset_type],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Truck Loan": {
		loanPurpose: [...loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Equipment Loan": {
		loanPurpose: [loan_purpose[1]],
		purchaseStage: [...purchase_stage],
		assetType: [...equipment_asset_type],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Caravan Loan": {
		loanPurpose: [...loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [],
		gstStatus: [],
		creditHistory: [...credit_history],
	},
	"Motorcycle Loan": {
		loanPurpose: [...loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [],
		gstStatus: [],
		creditHistory: [...credit_history],
	},
	"Bike Loan": {
		loanPurpose: [...loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [],
		gstStatus: [],
		creditHistory: [...credit_history],
	},
	"Personal Loan": {
		loanPurpose: [...personal_loan_purpose],
		purchaseStage: [],
		assetType: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [],
		gstStatus: [],
		creditHistory: [...credit_history],
	},
};

export const stepProcessMap: Record<string, Record<string, any>> = {
	// Default Steps
	Default: [
		{
			id: 0,
			name: "Personal Details",
		},
		{
			id: 1,
			name: "Verification",
		},
		{
			id: 2,
			name: "Loan Details",
		},
		{
			id: 3,
			name: "Living Details",
		},
		{
			id: 4,
			name: "Additional Information",
		},
		{
			id: 5,
			name: "Completed",
		},
	],
};

// App theme settings
export const appSettingsConfig: Record<string, Record<string, string>> = {
	"Jade Finance": {
		themeColor: "#19cc76",
		hoverColor: "#16ac6b",
		themeHeaderTxt: "#142f48",
		bulletBG: "#bbf7d0",
	},
	"Jade Boat Loans": {
		themeColor: "#599bf8",
		hoverColor: "#457ac4",
		themeHeaderTxt: "#142f48",
		bulletBG: "#DBEAFE",
	},
	"Jade Car Loans": {
		themeColor: "#da1710",
		hoverColor: "#c51a14",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FFC9C9",
	},
	"Jade Caravan Finance": {
		themeColor: "#FF7901",
		hoverColor: "#e46701",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FFD6A7",
	},
	"Jade Equipment Finance": {
		themeColor: "#069f2e",
		hoverColor: "#068026",
		themeHeaderTxt: "#142f48",
		bulletBG: "#D0FAE5",
	},
	"Jade Truck Loans": {
		themeColor: "#ffc913",
		hoverColor: "#e9b814",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FEF9C2",
	},
	"Jade Bike Loans": {
		themeColor: "#0e8fbe",
		hoverColor: "#0d7ea7",
		themeHeaderTxt: "#142f48",
		bulletBG: "#DFF2FE",
	},
};
